"use strict";
var Model = require("../types/Model.js");

module.exports = Model({
	name: "careplansection",
	init: init,
	triggers: triggers,
	listeners: listeners,

	_section: "",
	_section_tracker: null,

	reset: reset,
	refresh: refresh,
});

function init() {
	this.reset();
}

function triggers() {
	return {
		view: view,
		reset: reset,
	};
}

function listeners() {
	return {
		"connectivity:online": refresh
	};
}

function reset() {
	this._section = "";
	this.push({});
}

function view(data) {
	var section = data.section;

	this._section = section;
	this.emit("careplanschema:trigger:load");
	this.refresh();
}

function handle_loaded(data) {
	this.push(data);
}

function finish_save() {
	this.emit("save:trigger:finish");
}

function refresh() {
	var section = this._section;
	if(!section) return;

	this.emit("save:trigger:start");
	return this.api.careplan.section(section)
		.then(handle_loaded.bind(this))
		.catch(console.error.bind(console))
		.then(finish_save.bind(this));
}
